<template>
  <div class="choose_account" :class="{ nonSteps: !showSteps }">
    <div v-show="showSteps" clsss="stepBlock">
      <PaymentSteps :currentStep="0" :stepsData="stepsData"></PaymentSteps>
    </div>
    <div class="w-full">
      <paymentForm
        :show-max-btn="false"
        :accountNumberOptions="formAccountOptions"
        :validAmount="validAmount"
        @submit="submitClick"
        @amountChange="amountChange"
        @accountNumberChange="accountNumberChange"
        @accountCurrencyChange="accountCurrencyChange"
        :min="minLimitAmount"
        :max="maxLimitAmount"
        :btnDisabled="btnDisabled"
      >
        >
        <template #amount>
          <DepositVoucher
            :depositAccount="accountNumber"
            :depositAmount="depositAmount"
            :currency="currency"
            @selectVoucherChange="selectVoucherChange"
          />
        </template>
      </paymentForm>
    </div>
  </div>
</template>
<script>
import paymentForm from '@/components/payment/paymentForm.vue';
import PaymentSteps from '@/components/payment/PaymentSteps.vue';
import DepositVoucher from './DepositVoucher.vue';
import { apiQuery_mt_accounts_all } from '@/resource';
import { depositStepData } from '@/constants/payment/pcsDepositSetting.json';

export default {
  name: 'ChooseAccount',
  props: {
    showSteps: {
      type: Boolean,
      default: true
    }
  },
  components: { paymentForm, DepositVoucher, PaymentSteps },
  data() {
    return {
      valid: false,
      formAccountOptions: [],
      depositAmount: 0,
      accountNumber: null,
      currency: null,
      redemptionCode: null,
      vouvherApplied: null,
      maxLimitAmount: null,
      minLimitAmount: null,
      btnDisabled: false,
      accountType: null,
      accountPlatform: null,
      userCouponId: null,
      capAmount: null,
      couponType: null
    };
  },
  computed: {
    stepsData() {
      return depositStepData.map((element, index) => {
        return {
          step: index,
          title: this.$t(element.title),
          description: this.$t(element.description),
          icon: require(`@/assets/images/withdraw/${element.icon}`)
        };
      });
    }
  },
  methods: {
    async fetchTradingAccount() {
      try {
        const res = await apiQuery_mt_accounts_all({ supportedCurrencies: 'all' });
        if (res.data.code === 0 && res.data.data.length > 0) {
          this.formAccountOptions = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    accountNumberChange(value) {
      const jsonParse = JSON.parse(value);
      this.accountNumber = jsonParse.account;
      const seletedOption = this.formAccountOptions.find(option => option.mt4_account === this.accountNumber);
      const { depositMinAmount, depositMaxAmount } = seletedOption;
      this.minLimitAmount = seletedOption.depositMinAmount;
      this.maxLimitAmount = seletedOption.depositMaxAmount;
      if (depositMinAmount && depositMaxAmount) {
        this.btnDisabled = false;
      } else {
        this.btnDisabled = true;
      }
      this.$emit('update:accountType', jsonParse.accountType);
      this.$emit('update:accountPlatform', jsonParse.platform);
      this.$emit('update:accountNumber', jsonParse.account);
    },
    accountCurrencyChange(value) {
      this.currency = value;
      this.$emit('update:currency', value);
    },
    amountChange(value, errMsg) {
      this.depositAmount = value;
      this.$emit('update:amount', value);
      this.$emit('update:amountErrMsg', errMsg);
    },
    selectVoucherChange(data) {
      this.redemptionCode = data.redemptionCode;
      this.$emit('update:redemptionCode', data.redemptionCode);
      this.$emit('update:voucherApplied', data.voucherApplied);
      this.$emit('update:userCouponId', data.userCouponId);
      this.$emit('update:capAmount', data.capAmount);
      this.$emit('update:couponType', data.couponType);
    },
    validAmount(value, callback) {
      const parseValue = parseFloat(value);
      if (this.minLimitAmount === null || this.maxLimitAmount === null) {
        callback && callback(new Error(this.$t('deposit.default.noMaxMinLimit')));
      } else if (parseValue <= 0) {
        callback && callback(new Error(this.$t('common.formValidation.amtReq')));
        return false;
      } else if (parseValue < this.minLimitAmount) {
        callback &&
          callback(
            new Error(
              this.$t('common.formValidation.amtLarger', { currencyType: this.currency, minLimit: this.minLimitAmount })
            )
          );
        return false;
      } else if (parseValue > this.maxLimitAmount) {
        callback &&
          callback(
            new Error(
              this.$t('common.formValidation.maxAmount', { maxLimit: this.maxLimitAmount, currency: this.currency })
            )
          );
        return false;
      } else {
        callback && callback();
        return true;
      }
    },
    submitClick(valid) {
      this.valid = valid;
      this.submit(valid);
    },
    submit(valid) {
      this.$emit('submit', valid);
    }
  },
  mounted() {
    this.fetchTradingAccount();
  }
};
</script>
<style lang="scss" scoped>
.choose_account {
  background-color: #fff;
  display: flex;
  justify-content: center;
  padding: 80px 47px 40px;
  border-radius: 20px;

  @include screen-mobile {
    padding: 40px 24px;
  }
}
.stepBlock {
  // padding: 0 40px;
  // flex-basis: 50%;
  // flex-grow: 1;
}
.w-full {
  width: 100%;
  max-width: 500px;
  flex-basis: 50%;
  flex-grow: 1;
  @include rtl-sass-prop(margin-left, margin-right, 200px);
}
.choose_account.nonSteps {
  .w-full {
    @include rtl-sass-prop(margin-left, margin-right, 0);
    max-width: none;
  }
}
</style>
